// JSON Formatter / Validator Tool — pretty-print, minify and validate JSON.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const jsonFormatterTool: Tool = {
  id: "json-formatter",
  name: () => m.jf_tool_name(),
  description: () => m.jf_tool_description(),
  icon: "📋",
  basePath: "/json-formatter",
  status: "stable",
  tags: ["json", "format", "validator", "developer"],
  pages: [
    {
      name: () => m.jf_nav_main(),
      path: "/json-formatter",
      description: () => m.jf_nav_main_desc(),
      icon: "📋",
    },
  ],
};
